var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "360.000000pt",
    height: "360.000000pt",
    viewBox: "0 0 360.000000 360.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,360.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1630 3200 c-616 -86 -1082 -518 -1212 -1123 -31 -146 -31 -408 0 -554 121 -566 539 -984 1105 -1105 146 -31 408 -31 554 0 283 61 519 188 718 387 199 199 326 434 387 718 31 145 31 407 0 554 -121 567 -544 989 -1105 1104 -116 23 -345 33 -447 19z m371 -186 c491 -83 889 -458 1000 -944 29 -128 36 -332 15 -461 -44 -264 -166 -500 -356 -687 -40 -40 -75 -71 -76 -69 -2 1 -19 104 -39 227 -19 124 -40 237 -46 251 -15 38 -67 85 -119 108 -111 48 -384 91 -580 91 -196 0 -469 -43 -580 -91 -52 -23 -104 -70 -119 -108 -6 -14 -27 -127 -46 -251 -20 -123 -38 -226 -39 -227 -7 -7 -159 153 -205 214 -111 148 -195 350 -227 542 -21 129 -14 333 15 461 110 484 505 858 996 944 109 19 292 19 406 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1668 2664 c-95 -22 -177 -70 -254 -148 -85 -85 -128 -167 -151 -285 -54 -274 122 -554 393 -626 76 -20 212 -20 288 0 196 52 348 216 391 420 18 88 18 132 0 220 -43 204 -207 373 -407 420 -77 18 -184 18 -260 -1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1Icon);
export default __webpack_public_path__ + "static/media/Image-1icon.5919a67ee5f0732e9f2733953d907d36.svg";
export { ForwardRef as ReactComponent };